import React from 'react';
import styles from './RouteStatusBadge.module.css';
import { RouteStatusType } from '../routesTypes';

interface RouteStatusBadgeProps {
  status: RouteStatusType;
}

export const RouteStatusBadge: React.FC<RouteStatusBadgeProps> = ({ status }) => {
  return (
    <span className={`${styles.badge} ${styles[status.toLowerCase()]}`}>
      {status}
    </span>
  );
};
